// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { TopProgressBarService } from '@modules/top-progress-bar/shared/services/top-progress-bar.service';
// import { tap, catchError } from 'rxjs/operators';

// export const TopProgressBarSkipHeader = 'T-Skip-Interceptor';
// @Injectable()
// export class TopProgressBarInterceptor implements HttpInterceptor {
//   constructor(private topBarService: TopProgressBarService) {}
//   /**
//    *
//    *
//    * @param {HttpRequest<any>} request
//    * @param {HttpHandler} next
//    * @returns {Observable<HttpEvent<any>>}
//    * @memberof TopProgressBarInterceptor
//    */
//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

//     if (request.method === 'GET' && !request.headers.has(TopProgressBarSkipHeader)) {
//       this.topBarService.showTopProgressBar();
//     }

//     const headers = request.headers.delete(TopProgressBarSkipHeader);

//     return next.handle(request.clone({headers})).pipe(
//       tap((event: HttpEvent<any>) => {
//         if (event instanceof HttpResponse) {
//           this.topBarService.hideTopProgressBar();
//         }
//       }),
//       catchError((error) => {
//         this.topBarService.hideTopProgressBar();
//         return throwError(error);
//       }) as any,
//     );
//   }
// }

import { HttpRequest, HttpHandlerFn, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { TopProgressBarService } from '@shared/services/top-progress-bar.service';

export const TopProgressBarSkipHeader = 'T-Skip-Interceptor';

export const topProgressBarInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const topBarService = inject(TopProgressBarService);

  if (request.method === 'GET' && !request.headers.has(TopProgressBarSkipHeader)) {
    topBarService.showTopProgressBar();
  }

  const headers = request.headers.delete(TopProgressBarSkipHeader);

  return next(request.clone({ headers })).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        topBarService.hideTopProgressBar();
      }
    }),
    catchError((error) => {
      topBarService.hideTopProgressBar();
      return throwError(() => error);
    })
  );
};
